(function () {
  'use strict';

  /* ---- Wordmark: size "& COLLECTIBLES" so it spans exactly the width of "CAPE CARDS" ---- */
  function fitWordmark() {
    var a = document.querySelector('.wm .a'), b = document.querySelector('.wm .b');
    if (!a || !b) return;
    var n = b.textContent.length, aw = a.getBoundingClientRect().width;
    var fs = parseFloat(getComputedStyle(a).fontSize) * 0.54;
    b.style.letterSpacing = '0'; b.style.marginRight = '0'; b.style.fontSize = fs + 'px';
    var w0 = b.getBoundingClientRect().width, ls = (aw - w0) / (n - 1);
    b.style.letterSpacing = ls + 'px'; b.style.marginRight = (-ls) + 'px';
  }

  /* ---- Hero slideshow ---- */
  function initHero(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var track = root.querySelector('[data-slides]');
    var dots = [].slice.call(root.querySelectorAll('[data-dot]'));
    var count = track.children.length, timer;
    function cur() { return Math.round(track.scrollLeft / track.clientWidth); }
    function go(i) { track.scrollTo({ left: (((i % count) + count) % count) * track.clientWidth, behavior: 'smooth' }); }
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); restart(); }); });
    var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { go(cur() - 1); restart(); });
    if (next) next.addEventListener('click', function () { go(cur() + 1); restart(); });
    track.addEventListener('scroll', function () {
      var c = cur(); dots.forEach(function (d, j) { d.classList.toggle('on', c === j); });
    }, { passive: true });
    function restart() {
      clearTimeout(timer);
      if (root.dataset.autoplay !== 'true' || count < 2) return;
      timer = setTimeout(function () { go(cur() + 1); restart(); }, parseInt(root.dataset.delay, 10) || 6000);
    }
    restart();
  }

  /* ---- Collection sort ---- */
  function initSort() {
    var sel = document.querySelector('[data-sort]');
    if (!sel) return;
    sel.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  }

  /* ---- Product page: gallery + variant select ---- */
  function initProduct() {
    var root = document.querySelector('[data-product]');
    if (!root) return;
    var main = root.querySelector('[data-gallery-main]');
    root.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var img = main.querySelector('img');
        if (!img) { img = document.createElement('img'); main.insertBefore(img, main.firstChild); }
        img.src = t.dataset.thumb; img.alt = t.dataset.alt || '';
        root.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.toggle('on', x === t); });
      });
    });
    var sel = root.querySelector('select[data-variants]');
    if (!sel) return;
    var price = root.querySelector('[data-price]'), stock = root.querySelector('[data-stock]'), add = root.querySelector('[data-add]');
    sel.addEventListener('change', function () {
      var o = sel.options[sel.selectedIndex], ok = o.dataset.available === 'true';
      price.innerHTML = o.dataset.price + (o.dataset.compare ? '<s>' + o.dataset.compare + '</s>' : '');
      stock.textContent = ok ? 'In stock' : 'Sold out';
      add.disabled = !ok; add.textContent = ok ? 'Add to cart' : 'Sold out';
    });
  }

  /* ---- Filters: apply as soon as a box is ticked ---- */
  function initFilters() {
    document.querySelectorAll('[data-filters]').forEach(function (f) {
      if (f.dataset.ready) return; f.dataset.ready = '1';
      f.addEventListener('change', function (e) {
        if (e.target.type === 'number') return;          // price boxes wait for Enter or blur
        f.submit();
      });
      f.querySelectorAll('input[type="number"]').forEach(function (n) {
        n.addEventListener('blur', function () { if (n.defaultValue !== n.value) f.submit(); });
        n.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); f.submit(); } });
      });
      // on phones start collapsed so the products come first
      var box = f.closest('.filters-box');
      if (box && window.matchMedia('(max-width: 900px)').matches && !f.querySelector('.chip')) box.removeAttribute('open');
    });
  }

  function init() {
    initFilters();
    fitWordmark();
    document.querySelectorAll('[data-hero]').forEach(initHero);
    initSort(); initProduct();
  }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitWordmark);
  window.addEventListener('resize', fitWordmark);
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();


/* external-links: anything pointing off this store opens in a new tab */
(function () {
  function mark(root) {
    var links = (root || document).querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      try {
        var u = new URL(a.href, location.href);
        if ((u.protocol === 'http:' || u.protocol === 'https:') && u.host !== location.host) {
          a.target = '_blank';
          a.rel = ((a.rel || '') + ' noopener noreferrer').trim();
        }
      } catch (e) { /* ignore bad links */ }
    }
  }
  if (document.readyState !== 'loading') mark(); else document.addEventListener('DOMContentLoaded', function () { mark(); });
  new MutationObserver(function () { mark(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
